
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { PAGE_ID } from "@/const/log-const";
import { BeaconLogInfo } from "@/types/common";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "RecipeVideoView",
  props: {
    /**
     * 画像
     */
    imageUrl: {
      type: String
    },
    videoUrl: {
      type: String
    },
    recipeId: {
      type: String,
      default: ""
    },
    recipeType: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const OBJECT_ID_BUTTON_MOVIE = "btn_movie_1";
    const STATE = {
      STATE_NONE: "state_none",
      STATE_LOADING: "state_loading",
      STATE_PLAYING: "state_playing",
      STATE_ERROR: "state_error",
      STATE_PAUSE: "state_pause",
      STATE_VISIBLE_STOP: "state_visibie_stop"
    };
    const videoElement = ref<InstanceType<typeof HTMLVideoElement>>();
    const seekbarLoad = ref<InstanceType<typeof HTMLDivElement>>();
    const seekbarOut = ref<InstanceType<typeof HTMLDivElement>>();
    const seekbarIn = ref<InstanceType<typeof HTMLDivElement>>();
    const state = ref(STATE.STATE_NONE);
    let url = "";
    const loadingTimerId = ref(-1);
    const LOADING_WAIT_TIMER = 15 * 1000;
    const isSetListener = ref(false);

    const isStateNone = () => {
      return state.value == STATE.STATE_NONE;
    };
    const isStatePlaying = () => {
      return state.value == STATE.STATE_PLAYING;
    };
    const isStateError = () => {
      return state.value == STATE.STATE_ERROR;
    };
    const isShowControl = () => {
      return (
        state.value == STATE.STATE_PLAYING
        || state.value == STATE.STATE_PAUSE
        || state.value == STATE.STATE_VISIBLE_STOP
      );
    };
    // ページの表示状態が変わったときに実行
    document.addEventListener(
      "visibilitychange",
      function() {
        NativeClient.sendDebugLog(
          "RecipeVideoView visibilitychange=" + document.visibilityState
        );
        if (document.visibilityState === "hidden") {
          if (videoElement.value) {
            videoElement.value.pause();
            NativeClient.sendDebugLog(
              "RecipeVideoView visibilitychange hidden state.value=" + state.value
            );
          }
        } else if (document.visibilityState === "visible") {
          if (NativeClient.isAndroid()) {
            // 自動再生されるのを回避するため、状態切り替え
            state.value = STATE.STATE_VISIBLE_STOP;
          }
          NativeClient.sendDebugLog(
            "RecipeVideoView visibilitychange visible state.value=" + state.value
          );
        }
      },
      false
    );
    const clearLoadingTimer = () => {
      NativeClient.sendDebugLog(
        "RecipeVideoView LoadingTimer clear timerId=" +
          loadingTimerId.value +
          " state=" +
          state.value
      );
      clearInterval(loadingTimerId.value);
      loadingTimerId.value = -1;
    };
    const setLoadingTimer = () => {
      if (loadingTimerId.value != -1) {
        clearLoadingTimer();
      }
      loadingTimerId.value = window.setInterval(() => {
        NativeClient.sendDebugLog(
          "RecipeVideoView LoadingTimer timeout timerId=" +
            loadingTimerId.value +
            " state=" +
            state.value
        );
        clearLoadingTimer();
        state.value = STATE.STATE_ERROR;
      }, LOADING_WAIT_TIMER);
      NativeClient.sendDebugLog(
        "RecipeVideoView LoadingTimer set timerId=" +
          loadingTimerId.value +
          " state=" +
          state.value
      );
    };
    const removeEventListener = () => {
      if (videoElement.value) {
        NativeClient.sendDebugLog(
          "RecipeVideoView removeEventListener play state=" + state.value
        );
        videoElement.value.removeEventListener("error", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener error state=" + state.value
          );
        });
        videoElement.value.removeEventListener("playing", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener playing state=" + state.value
          );
        });
        videoElement.value.removeEventListener("abort", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener abort state=" + state.value
          );
        });
        videoElement.value.removeEventListener("pause", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener pause state=" + state.value
          );
        });
        videoElement.value.removeEventListener("ended", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener error state=" + state.value
          );
        });
        videoElement.value.removeEventListener("blur", function() {
          NativeClient.sendDebugLog(
            "RecipeVideoView removeEventListener error state=" + state.value
          );
        });
        isSetListener.value = false;
      }
    };
    const setEventListener = () => {
      if (videoElement.value) {
        NativeClient.sendDebugLog(
          "RecipeVideoView setEventListener state=" + state.value
        );
        videoElement.value.addEventListener("error", () => {
          NativeClient.sendDebugLog(
            "RecipeVideoView setEventListener error event  state=" +
              state.value +
              " code=" +
              videoElement.value?.error?.code +
              " message=" +
              videoElement.value?.error?.message
          );
          clearLoadingTimer();
          state.value = STATE.STATE_ERROR;
        });
        videoElement.value.addEventListener("playing", () => {
          let time = 0;
          let logTime = 0;
          if (videoElement.value != null) {
            time = videoElement.value.currentTime;
            logTime = Math.floor(time);
          }
          NativeClient.sendDebugLog(
            "RecipeVideoView setEventListener playing event state=" + 
              state.value + " time=" + time + " logTime=" + logTime
          );
          if (state.value == STATE.STATE_PAUSE) {
            const viewedItem = Array<string>();
            viewedItem.push("start_mid");
            viewedItem.push(String(logTime));
            viewedItem.push(props.recipeId);
            viewedItem.push(props.recipeType);
            const logInfo = new BeaconLogInfo(PAGE_ID.RECIPE_DETAIL, OBJECT_ID_BUTTON_MOVIE, viewedItem);
            NativeClient.sendClickedActionLog(logInfo);
          }
          if (state.value == STATE.STATE_VISIBLE_STOP) {
            if (videoElement.value != null) {
              videoElement.value.pause();
            }
          } else if (
            state.value == STATE.STATE_LOADING ||
            state.value == STATE.STATE_NONE ||
            state.value == STATE.STATE_PAUSE
          ) {
            state.value = STATE.STATE_PLAYING;
          }
          clearLoadingTimer();
        });
        videoElement.value.addEventListener("abort", () => {
          NativeClient.sendDebugLog(
            "RecipeVideoView setEventListener error event state=" +
              state.value +
              " code=" +
              videoElement.value?.error?.code +
              " message=" +
              videoElement.value?.error?.message
          );
          clearLoadingTimer();
          state.value = STATE.STATE_ERROR;
        });
        videoElement.value.addEventListener("pause", () => {
          if (!(state.value == STATE.STATE_VISIBLE_STOP || state.value == STATE.STATE_PAUSE)) {
            let time = 0;
            let logTime = 0;
            if (videoElement.value != null) {
              time = videoElement.value.currentTime;
              logTime = Math.floor(time);
            }
            const viewedItem = Array<string>();
            viewedItem.push("stop");
            viewedItem.push(String(logTime));
            viewedItem.push(props.recipeId);
            viewedItem.push(props.recipeType);
            const logInfo = new BeaconLogInfo(PAGE_ID.RECIPE_DETAIL, OBJECT_ID_BUTTON_MOVIE, viewedItem);
            NativeClient.sendClickedActionLog(logInfo);
            NativeClient.sendDebugLog(
              "RecipeVideoView setEventListener pause event state=" + state.value + " time=" + time + " logTime=" + logTime
            );
          }
          state.value = STATE.STATE_PAUSE;
        });
        videoElement.value.addEventListener("ended", () => {
          NativeClient.sendDebugLog(
            "RecipeVideoView setEventListener ended event state=" + state.value
          );
          if (videoElement.value) {
            videoElement.value.currentTime = 0;
          }
          if (state.value != STATE.STATE_NONE) {
            const viewedItem = Array<string>();
            viewedItem.push("end");
            viewedItem.push(props.recipeId);
            viewedItem.push(props.recipeType);
            const logInfo = new BeaconLogInfo(PAGE_ID.RECIPE_DETAIL, null, viewedItem);
            NativeClient.sendViewedLog(logInfo);
          }
          state.value = STATE.STATE_NONE;

        });
        videoElement.value.addEventListener("blur", () => {
          NativeClient.sendDebugLog("RecipeVideoView setEventListener blur event state=" + state.value);
        });
        videoElement.value.addEventListener("timeupdate", function () {
          let bufferNo = 0;
          if (videoElement.value != null && seekbarLoad.value != null && seekbarOut.value != null && seekbarIn.value != null) {
            seekbarIn.value.style.transform = `scaleX(${videoElement.value.currentTime / videoElement.value.duration})`;
            for (let i = (videoElement.value.buffered.length); bufferNo == undefined && videoElement.value.buffered.length != 0 && i != 0; i--) {
                if (videoElement.value.buffered.start(i - 1) < videoElement.value.currentTime) {
                    bufferNo = videoElement.value.buffered.end(i - 1);
                }
            }
            seekbarLoad.value.style.transform = `scaleX(${bufferNo / videoElement.value.duration})`;
          }
        }, false);
        isSetListener.value = true;
      }
    };
    const videoPlay = () => {
      NativeClient.sendDebugLog(
        "RecipeVideoView videoPlay videoElement=" +
          JSON.stringify(videoElement.value)
      );
      if (videoElement.value) {
        NativeClient.sendDebugLog(
          "RecipeVideoView videoPlay play state=" + state.value + " isSetListener=" + isSetListener.value
        );
        state.value = STATE.STATE_LOADING;
        if (url == "") {
          url = props.videoUrl ? props.videoUrl : "";
          videoElement.value.src = url;
          setLoadingTimer();
        }
        const viewedItem = Array<string>();
        viewedItem.push("start_first");
        viewedItem.push(props.recipeId);
        viewedItem.push(props.recipeType);
        const logInfo = new BeaconLogInfo(PAGE_ID.RECIPE_DETAIL, OBJECT_ID_BUTTON_MOVIE, viewedItem);
        NativeClient.sendClickedActionLog(logInfo);
        videoElement.value.play();
      }
    };
    NativeClient.sendDebugLog(
      "RecipeVideoView getHeight window width=" +
        window.innerWidth +
        " height=" +
        window.innerWidth * 0.75
    );
    const getHeight = () => {
      // 動画の表示サイズを横：縦 = 100:75 の割合で表示するために高さを算出
      const height = window.innerWidth * 0.75;
      return height + "px";
    };
    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      NativeClient.sendDebugLog(
        "RecipeVideoView onMounted state=" + state.value + " isSetListener=" + isSetListener.value
      );
      if (!isSetListener.value) {
        setEventListener();
      }
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      NativeClient.sendDebugLog(
        "RecipeVideoView onUnmounted state=" + state.value + " isSetListener=" + isSetListener.value
      );
      if (isSetListener.value) {
        removeEventListener();
      }
    });
    return {
      videoPlay,
      videoElement,
      isStatePlaying,
      isStateNone,
      isStateError,
      isShowControl,
      state,
      getHeight,
      seekbarLoad,
      seekbarOut,
      seekbarIn
    };
  }
});
